import bridge from '../core';

const apiName = 'openNewPage';
/**
 * 打开新页面
 * @param {JSON} data
 * @param {String} data.type native/web
 * @param {String} data.path 对于页面的URL
 * @param {JSON} data.params 参数
 * @param {Number} data.params.tab path若有tab栏的定位类型（左到右: 0、1、2...）
 * @param {JSON} data.isClose 是否关闭当前webview,1:关闭、0:不关闭(默认值，无需传)
 */
function fallback(data) {
    const { params, path } = data;
    if (path === 'articleDetailPage') {
        window.location.href = `http://${window.location.host}/h5/article/${params.id}`;
    }
    if (path === 'relicPage') {
        window.location.href = `http://${window.location.host}/h5/relic/${params.id}`;
    }
}

function back(params) {
    return {
        api: JSON.stringify(params),
        fallback
    };
}

bridge.register(apiName, back);
